import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import * as OnboardingSessionActions from "../../state/redux/onboardingSession";
import Portal from "../ui/portal";
import PortalGridContent from "../ui/portalGridContent";
import UserUnsubscribe from "../widgets/userUnsubscribe";

const onboardingKeySearchParam = "inviteKey";

const UnsubscribePortal = props => {
  const { organizationODM } = props;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const inviteKey = urlParams.get(onboardingKeySearchParam);

    props.setInviteKeyRequest(inviteKey);

    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const [backgroundImage, setBackgroundImage] = useState(`linear-gradient(#c5c0c2)`);

  useEffect(() => {
    if (organizationODM != null) {
      if (organizationODM.omniData.onboardingBackground) {
        setBackgroundImage(`url(${organizationODM.omniData.onboardingBackground})`);
      }
    }
  }, [organizationODM]);

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundImage: backgroundImage,
        backgroundSize: "cover",
      }}
    >
      <PortalGridContent hasPortalAppBar={false}>
        <Grid item xs={1} sm={1} md={2} lg={3} />
        <Grid item xs={12} sm={12} md={8} lg={6}>
          <UserUnsubscribe />
        </Grid>
        <Grid item xs={1} sm={1} md={2} lg={3} />
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  organizationODM: state.onboardingSession.organizationODM,
});

const mapDispatchToProps = {
  setInviteKeyRequest: OnboardingSessionActions.setInviteKeyRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnsubscribePortal));
